/**
 * Portfolio section: cards representing large-format prints "unroll"
 * horizontally as the user scrolls vertically past the section — like a
 * banner being fed off a roll. Section pins while the track translates.
 */
export function initPortfolioUnroll(gsap, ScrollTrigger) {
  const section = document.querySelector('.unroll-section');
  const track = document.querySelector('.unroll-track');
  if (!section || !track) return;

  const getScrollDistance = () => track.scrollWidth - window.innerWidth + 160;

  const tween = gsap.to(track, {
    x: () => -getScrollDistance(),
    ease: 'none',
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: () => `+=${getScrollDistance()}`,
      scrub: 0.8,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
    },
  });

  // Cards tilt slightly as they pass center screen — like sheets riding
  // through the press rollers
  gsap.utils.toArray('.unroll-card').forEach((card) => {
    gsap.fromTo(
      card,
      { rotate: -2, scale: 0.94 },
      {
        rotate: 2,
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: card,
          containerAnimation: tween,
          start: 'left 90%',
          end: 'right 10%',
          scrub: true,
        },
      }
    );
  });
}
